module.exports = __webpack_public_path__ + "img/arrows-split-up-and-left.be47394d.svg";